import IMG3 from "./img/crystal1.jpg";
import IMG4 from "./img/minion2.jpg";
import IMG6 from "./img/disney.jpg";
import IMG7 from "./img/giphy.gif";
import IMG8 from "./img/unpic.jpg";
import IMG9 from "./img/food.jpg";
import IMG10 from "./img/fun.jpg";
import IMG11 from "./img/clicky.jpg";
import IMG1 from "./img/bird.jpg";

const Sdata = [
  {
    id: 1,
    imgsrc: IMG11,
    title: "Clicky Game",
    summary:
      "Clicky Game is a simple memory game.It is a web app that utilizes React for the front end. Click to score but don't click the same card twice!",
    github: "https://github.com/sharmap1/Clicky-game",
    link: "https://polar-sea-94378.herokuapp.com/",
  },
  {
    id: 2,
    imgsrc: IMG3,
    title: "Crystal Collector",
    summary:
      "This is a fun game where there are four crystals which on click will add a specific amount of points to the total score. The user wins if the score earned  matches with the number displayed.",
    github: "https://github.com/sharmap1/Crystal-Collector",
    link: "https://sharmap1.github.io/Crystal-Collector/",
  },
  {
    id: 3,
    imgsrc: IMG4,
    title: "Minion Trivia",
    summary:
      "In this game, 10 questions are randomly generated with countdown timer for answer.App gives correct answer with gif/image after user guess. ",
    github: "https://github.com/sharmap1/Trivia-Game",
    link: "https://sharmap1.github.io/Trivia-Game/",
  },
  {
    id: 4,
    imgsrc: IMG6,
    title: "Disney Movies",
    summary: "This is a app which will showcase the top 10 Disney movies ever.",
    github: "https://github.com/sharmap1/Disney-Movies",
    link: "https://disney-movies.netlify.app/",
  },
  {
    id: 5,
    imgsrc: IMG7,
    title: "React-Giphy App",
    summary:
      "This is a front end app that uses GIPHY API to make a dynamic web page that populates gifs of user choice.",
    github: "https://github.com/sharmap1/Giphy-React-Hooks",
    link: "https://giphytastic.netlify.app/",
  },
  {
    id: 6,
    imgsrc: IMG8,
    title: "Unsplash-React App",
    summary:
      "This is a front end app that uses Unsplash API to make a dynamic web page that populates free images.",
    github: "https://github.com/sharmap1/Unsplash-React-Hooks",
    link: "https://freepicsunsplash.netlify.app/",
  },
  {
    id: 7,
    imgsrc: IMG9,
    title: "React-Recipe App",
    summary:
      "This is a front end app that uses Edemamme API to make a dynamic web page that populates recipe of user choice.",
    github: "https://github.com/sharmap1/Recipe-App",
    link: "https://festive-ardinghelli-bf981c.netlify.app/",
  },
  {
    id: 8,
    imgsrc: IMG10,
    title: "Fun App",
    summary:
      "This is a app which uses APIs to show cat facts, giphy, jokes, trivia questions, pokemon, quotes and unsplash images.",
    github: "https://github.com/sharmap1/Fun-App-React-Api",
    link: "https://gallant-hermann-01804b.netlify.app/",
  },
  {
    id: 9,
    imgsrc: IMG1,
    title: "Memory Game",
    summary:
      "The card memory game is a simple game to test the player’s memory made with react hooks.",
    github: "https://github.com/sharmap1/React-MemoryGame",
    link: "https://memory-game-react-hooks.netlify.app/",
  },
];

export default Sdata;
